import { Column } from "components/flexComponents/MultiColumnContainer/model/Column";
import { BaseColumnDecorator } from "components/flexComponents/MultiColumnContainer/decorators/BaseColumnDecorator";
import { OneColumn } from "components/flexComponents/MultiColumnContainer/model/OneColumn";
import { FlexComponent } from "typings/flexFramework/FlexComponent";

/**
 * Base class for supporting two columns
 */
export class TwoColumn extends BaseColumnDecorator {
  public leftColumn: Column;
  public rightColumn: Column;

  protected constructor(column: Column) {
    super(column);
  }

  public setLeftAndRightColumn(leftModules: FlexComponent[], rightModules: FlexComponent[]) {
    this.leftColumn = new OneColumn(leftModules, "50");
    this.rightColumn = new OneColumn(rightModules, "50");
  }

  public getColumnsToRender() {
    return [this.leftColumn, this.rightColumn];
  }
}
